import { get } from 'lodash';

import BaseService from './BaseService';
import CommonService from './CommonService';
import LocalStorageService from './LocalStorageService';
import MeveoClient from "../model/MeveoClient";
import Error from '../model/Error';
import Customer from '../model/account/Customer';
import ApplicationStore from '../framework/ApplicationStore';

class UserService extends BaseService {

	constructor() {
		super();
		this.serviceUrl = "/api/rest/user";
	}

	findUser(userName) {
		const url = "/api/rest/v2/generic/all/user";
		return this.opencellAPI
      .invokeRequest({
          filters: {
            userName
          }
        },
        url,
        "POST"
      )
      .then(response => {
        const user = get(response, "data[0]", {});

        return {
          actionStatus: {
            status: user ? 'SUCCESS' : 'FAIL'
          },
          user: {
            ...user,
            createdAt: get(user, 'auditable.created')
          }
        }
      });
	}

	initializeUser(auth, resume) {
		const userDetails = auth && auth.tokenParsed || {};
		const userName = userDetails["preferred_username"] || null;
		this.findUser(userName)
			.then(response => {
				const {actionStatus, user} = response;
				if (actionStatus === null) {
					throw null;
				} else if (actionStatus.status === "SUCCESS") {
					const userAccess = userDetails["resource_access"] || {};
					const scUserAccess = userAccess["opencell-sc"] || {};
					const userRoles = scUserAccess["roles"] || [];
					const isSCCustomer = userRoles.indexOf("customer") !== -1;
					const {createdAt, lastLoginDate} = user || "";
					if (userName !== null && isSCCustomer && (createdAt === lastLoginDate)) {
						return this.createAccount(userDetails, resume);
					}
					resume(user);
				} else {
					 throw actionStatus;
				}
			})
			.catch(error => {
				const {response = {}} = error;
				const {messages: mainMessages={}} = ApplicationStore.getState();
				const {messages = {}} = mainMessages || {};
				const message = ((response.status === 401) ? messages["common.error.access.denied"] : error.message);
				resume(null, new Error({message}));
			});
	}

	createAccount(userDetails, resume) {
		const newAccount = new MeveoClient({
			userName: userDetails["preferred_username"],
			email: userDetails["email"],
			firstName: userDetails["given_name"],
			lastName: userDetails["family_name"]
		}, true);

		return this.opencellAPI.createCRMAccountHierarchy(newAccount)
			.then(() => {
				return this.findUser(newAccount.code)

			})
			.then(response => {
				const {actionStatus, user} = response;
				if (actionStatus === null) {
					throw null;
				} else {
					resume(user);
				}
			})
			.catch(error => {
				const {response = {}} = error;
				const {messages: mainMessages={}} = ApplicationStore.getState();
				const {messages = {}} = mainMessages || {};
				const message = ((response.status === 401) ? messages["common.error.access.denied"] : error.message);
				resume(null, new Error({message}));
			});
	}

	loginUser(login, resume) {
		CommonService.login(login)
			.then(response => {
				const {actionStatus, customers} = response;
				const {customer} = customers || {};
				const [firstCustomer] = customer || [];
				if (actionStatus === null || actionStatus.status === "FAIL") {
					resume && resume(new Error(actionStatus));
				} else if (firstCustomer === null) {
					resume && resume(new Error({message: "Customer is not yet registered."}));
				} else {
					const customer = new Customer(firstCustomer);
					LocalStorageService.setCurrentCustomer(customer);
					resume && resume();
				}
			})
			.catch(error => {
				const {response = {}} = error;
				if (response.status === 401) {
					resume && resume(new Error({message: "Invalid user name or password."}))
				} else {
					resume && resume(new Error(error));
				}
			});
	}
}

const userService = new UserService();

export default userService;



// WEBPACK FOOTER //
// ./src/opencell/services/UserService.js